import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-label-next",
  "use": "icon-label-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-label-next\">\n<path d=\"M6 15C4.89543 15 4 14.1046 4 13L4 11C4 9.89543 4.89543 9 6 9L18 9C19.1046 9 20 9.89543 20 11L20 13C20 14.1046 19.1046 15 18 15L6 15Z\" fill=\"currentColor\" />\n<path d=\"M7 12L17 12\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol